// Korporativ saytlar — xizmat sahifasi kontenti (Innobek)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "Korporativ sayt yaratish — narxi 9 mln so'mdan | Innobek",
        description:
            "Kompaniyangiz uchun korporativ sayt yaratish 9 mln so'mdan. Ko'p sahifali tuzilma, admin panel, uch til va SEO. Muddat 12–35 ish kuni.",
        keywords: [
            "korporativ sayt",
            "korporativ sayt yaratish",
            "korporativ sayt narxi",
            "kompaniya uchun sayt",
            "biznes uchun sayt",
            "ko'p sahifali sayt",
            "Toshkentda sayt yaratish",
            "sayt buyurtma qilish",
            "veb-sayt ishlab chiqish",
        ],
    },
    hero: {
        eyebrow: "Korporativ saytlar",
        h1: "Korporativ sayt yaratish — 9 mln so'mdan",
        lead:
            "Mijoz, hamkor va investor siz bilan uchrashishdan oldin sizni internetdan qidiradi. Korporativ sayt — kompaniyangizning rasmiy yuzi: xizmatlar, loyihalar, jamoa va hujjatlar bitta tizimda, ikki-uch tilda va Google topadigan holatda.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "60+ topshirilgan veb-loyiha",
            "Next.js va React asosida",
            "uz / ru / en tillarida",
            "6 oylik texnik qo'llab-quvvatlash",
        ],
    },
    intro: {
        h: "Korporativ sayt nima va u kompaniyangizga nima beradi?",
        p: [
            "Korporativ sayt — kompaniya haqidagi ma'lumot tizimli tarzda joylashtirilgan ko'p sahifali veb-sayt. Bir sahifali landingdan farqi shunda: bu yerda alohida bo'limlar bo'ladi — kompaniya haqida, xizmatlar yoki mahsulotlar, amalga oshirilgan loyihalar, jamoa, sertifikat va litsenziyalar, yangiliklar, vakansiyalar va aloqa. Har bir bo'lim o'z manziliga ega, ya'ni Google'da har biri alohida so'rov bo'yicha chiqishi mumkin.",
            "Kompaniya uchun sayt bugun «bo'lsa yaxshi» darajasidagi narsa emas. Tenderda, chet ellik yetkazib beruvchi bilan muzokarada, bank kreditini rasmiylashtirishda yoki yirik mijoz bilan shartnoma tuzishda birinchi so'raladigan narsa — rasmiy sayt manzili. Sayti yo'q yoki 2015-yildan beri yangilanmagan kompaniya hujjatlari joyida bo'lsa ham jiddiy qabul qilinmaydi.",
            "Innobek korporativ saytni marketing bezagi sifatida emas, ish quroli sifatida quradi. Avval kompaniyangiz kimga va nimani sotishini aniqlaymiz, keyin shu mantiq asosida sahifalar tuzilmasini chizamiz. Matn, dizayn va texnik qism bir-biriga moslashadi: o'quvchi kerakli javobni uch klikdan kam vaqtda topadi, ariza shakli esa ko'z oldida turadi.",
            "Sayt Next.js yoki React asosida quriladi, admin panel orqali o'zingiz boshqarasiz va dastlabdan qidiruv tizimlariga tayyor holda topshiriladi. Biz uni yopiq konstruktorga qamab qo'ymaymiz — kod sizga beriladi, xohlagan paytda boshqa jamoaga ham topshirishingiz mumkin. Bu bog'liqlikni kamaytiradi va uzoq muddatda sizga foydali.",
        ],
    },
    definition: {
        term: "Korporativ sayt nima?",
        text:
            "Korporativ sayt — kompaniyaning xizmatlari, loyihalari, jamoasi va aloqa ma'lumotlarini bitta tizimda taqdim etadigan ko'p sahifali veb-sayt. U ishonch uyg'otish, mijoz jalb qilish va rasmiy taqdimot vazifasini bajaradi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya, biznes-tahlil va yozma texnik topshiriq",
            "Sayt tuzilmasi (sitemap) va har bir sahifaning bloklar mantiqi",
            "Ikki yoki uch tilli kontent tizimi (o'zbek / rus / ingliz)",
            "Barcha qurilmalarda tekshirilgan moslashuvchan dizayn",
            "Domen ro'yxatdan o'tkazishga yordam va DNS sozlash",
            "SSL sertifikati (HTTPS) va himoyalangan ariza shakllari",
            "Texnik SEO: meta teglar, sarlavhalar iyerarxiyasi, sitemap.xml, robots.txt",
            "Schema.org belgilash — Organization, Service va FAQ bloklari",
            "Google Analytics, Search Console va Yandex Metrika ulash",
            "Tezlikni optimallashtirish: rasm siqish, lazy-load, kesh",
            "Telegram'ga ariza bildirishnomasi va pochta orqali dublikat",
            "Boshqaruv bo'yicha video-qo'llanma va topshirish uchrashuvi",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "Korporativ sayt biznesga nima beradi",
        sub: "Sayt — xarajat emas, sotuv va obro' vositasi. Quyida u aniq nimaga ta'sir qiladi.",
        items: [
            {
                t: "Ishonch birinchi 10 soniyada",
                d: "Mijoz shartnomadan oldin sizni qidiradi. Tartibli sayt, real loyihalar, jamoa fotosuratlari va litsenziyalar — «biz jiddiy kompaniyamiz» degan eng arzon isbot. Bu narsalar bo'lmasa, mijoz raqobatchiga o'tadi.",
            },
            {
                t: "Google'dan doimiy murojaat",
                d: "Har bir xizmat uchun alohida sahifa — alohida so'rov bo'yicha chiqish imkoni. To'g'ri yozilgan 10 ta xizmat sahifasi 2–4 oydan keyin reklamaga to'lamasdan oyiga o'nlab murojaat keltira boshlaydi.",
            },
            {
                t: "Tender va yirik shartnomalar",
                d: "Davlat buyurtmasi, xalqaro hamkorlik va bank bilan ishlashda rasmiy sayt ko'pincha majburiy talab. Sayt yo'qligi yoki uning ishonchsiz ko'rinishi arizani hujjat bosqichidayoq to'xtatadi.",
            },
            {
                t: "Ko'p tilli auditoriya",
                d: "O'zbek, rus va ingliz tillari bitta tizimda, har biri alohida manzilda. Xorijiy hamkor sizni o'z tilida o'qiydi — muzokara tarjimonsiz va ancha oson boshlanadi.",
            },
            {
                t: "Kadr jalb qilish",
                d: "Vakansiya va jamoa bo'limi bilan sayt HR vositasiga aylanadi. Nomzod kompaniya madaniyatini, ofisni va loyihalarni ko'radi — ish e'lonlari saytiga qaraganda kuchliroq ta'sir qiladi.",
            },
            {
                t: "Boshqaruv sizning qo'lingizda",
                d: "Admin panel orqali yangilik chiqarasiz, loyiha qo'shasiz, narx va matnni o'zgartirasiz. Har kichik tuzatish uchun dasturchi kutib o'tirmaysiz va qo'shimcha to'lamaysiz.",
            },
            {
                t: "Marketing uchun poydevor",
                d: "Google Ads, Instagram yoki Telegram reklamasi qayerdadir tugashi kerak. Ishonchli sayt bo'lmasa, reklamaga sarflangan pul konversiyaga aylanmaydi — trafik kelib, ariza qoldirmasdan ketadi.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlar buyurtma qiladi",
        h: "Qanaqa bizneslarga korporativ sayt kerak",
        sub: "Bir sahifali sayt yetarli bo'lmaydigan, faoliyati keng va ishonch talab qiladigan sohalar.",
        items: [
            {
                t: "Ishlab chiqarish va zavodlar",
                d: "Mahsulot katalogi, sifat sertifikatlari, ishlab chiqarish quvvati va dilerlik bo'limi. Xaridor va hamkor uchun to'liq texnik ma'lumot bitta joyda turadi.",
            },
            {
                t: "Qurilish va loyihalash",
                d: "Topshirilgan obyektlar galereyasi, litsenziyalar, xizmatlar ro'yxati va jarayon tavsifi — tenderda birinchi navbatda tekshiriladigan narsalar.",
            },
            {
                t: "Tibbiyot: klinika va laboratoriya",
                d: "Yo'nalishlar, shifokorlar, narxlar va onlayn navbat. Bemor uchun ishonch birinchi o'rinda: diplom, tajriba va real sharhlar ko'rinib turishi kerak.",
            },
            {
                t: "Ta'lim: universitet, markaz, akademiya",
                d: "Dasturlar, o'qituvchilar, qabul shartlari va narxlar. Ariza to'g'ridan-to'g'ri saytdan qabul qilinadi va CRM'ga tushadi.",
            },
            {
                t: "Logistika, savdo va distribyutsiya",
                d: "Xizmat geografiyasi, tarif hisoblagichi, hamkorlar ro'yxati va yuk holatini kuzatish — barchasi bitta tizimda birlashtiriladi.",
            },
            {
                t: "Moliya, huquq va konsalting",
                d: "Ekspertiza, jamoa, keyslar va maqolalar. Bu sohalarda saytdagi kontent bevosita mijoz ishonchiga va murojaatga aylanadi.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Korporativ sayt narxi — uchta tarif",
        sub: "Narxlar oshkora. Har bir tarifga ko'p tillilik, domen sozlash, hosting'ga joylashtirish va qo'llab-quvvatlash kiradi.",
        note:
            "Ko'rsatilgan summalar boshlang'ich oraliq. Yakuniy narx sahifalar soni, integratsiyalar va kontent hajmiga qarab bepul konsultatsiyadan keyin tasdiqlanadi. To'lov bosqichma-bosqich: 50% oldindan, 50% topshirishda. Hosting va domen yillik to'lovi (taxminan 1–2 mln so'm) narxga kirmaydi.",
        tiers: [
            {
                name: "Standart",
                tagline: "Tez ishga tushadigan korporativ sayt",
                price: "9 000 000",
                priceNote: "so'mdan — loyihaga qarab",
                term: "12–18 ish kuni",
                features: [
                    "6–10 ta sahifa: bosh sahifa, biz haqimizda, xizmatlar, loyihalar, aloqa",
                    "Tayyor asosda brendingizga moslashtirilgan dizayn",
                    "Ikki tilli interfeys (o'zbek va rus), uchinchi til — qo'shimcha",
                    "Telefon, planshet va kompyuterga to'liq moslashuv",
                    "Ariza shakli va Telegram'ga bildirishnoma",
                    "Texnik SEO: meta teglar, sitemap, robots.txt, Schema.org",
                    "Google Analytics va Search Console ulash",
                    "Domen, hosting va SSL sozlash",
                    "Kontent tuzatishlari qo'llab-quvvatlash muddatida biz tomonimizdan",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
                best: "Sayti umuman yo'q yoki eskirgan, tez va ishonchli chiqishi kerak bo'lgan kompaniyalar",
            },
            {
                name: "Biznes",
                tagline: "Individual dizayn va to'liq admin panel",
                price: "22 000 000",
                priceNote: "so'mdan — loyihaga qarab",
                term: "25–35 ish kuni",
                features: [
                    "12–25 ta sahifa, keyinchalik kengaytiriladigan tuzilma",
                    "Noldan chizilgan individual dizayn, Figma maketi bilan",
                    "To'liq admin panel: sahifa, xizmat, loyiha, yangilik va vakansiya",
                    "Uch til (uz / ru / en), har biri alohida tahrirlanadi",
                    "Xizmatlar katalogi va portfolio moduli — filtr va kategoriyalar bilan",
                    "Blog yoki yangiliklar bo'limi — doimiy SEO trafik uchun",
                    "Vakansiya va jamoa bo'limi",
                    "Sotuvga yo'naltirilgan professional matn (copywriting)",
                    "Kengaytirilgan SEO: kalit so'zlar tahlili, ichki bog'lanish, tezlik",
                    "CRM (amoCRM, Bitrix24) yoki Google Sheets bilan integratsiya",
                    "Animatsiya va scroll effektlari",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
                best: "Doimiy yangilik chiqaradigan, portfolio va vakansiyalarni o'zi boshqaradigan kompaniyalar",
                featured: true,
            },
            {
                name: "Korporativ+",
                tagline: "Individual yechim va integratsiyalar",
                price: "Kelishuv",
                priceNote: "asosida — 45 mln so'mdan boshlanadi",
                term: "Loyihaga qarab, 2–4 oy",
                features: [
                    "Filial va bo'linmalar uchun alohida bo'limlar, hududiy sahifalar",
                    "Shaxsiy kabinet: dilerlar, hamkorlar yoki mijozlar uchun",
                    "1C, ERP va ombor tizimlari bilan integratsiya",
                    "Kalkulyator, konfigurator, bron qilish yoki tender moduli",
                    "Hujjat aylanmasi va ichki arizalar tizimi",
                    "Yuklamaga chidamli infratuzilma: CDN, monitoring, zaxira nusxa",
                    "Xavfsizlik auditi va kirish huquqlarini boshqarish",
                    "Shaxsiy loyiha menejeri va kelishilgan SLA",
                ],
                best: "Ko'p filialli holdinglar, murakkab integratsiya va yuqori yuklama talab qiladigan loyihalar",
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Korporativ sayt qanday quriladi",
        sub: "Oltita bosqich. Har birining oxirida natijani ko'rasiz va yozma tasdiqlaysiz.",
        steps: [
            {
                t: "Tahlil va texnik topshiriq",
                d: "Biznesingizni, mijoz yo'lini va uchta raqobatchini o'rganamiz. Sayt qanday vazifani bajarishi kerakligini hujjat qilib yozamiz — keyinchalik barcha qarorlar shu hujjatga tayanadi.",
                time: "2–3 kun",
            },
            {
                t: "Tuzilma va matn",
                d: "Sahifalar xaritasi, har bir sahifaning bloklari va matni tayyorlanadi. Kalit so'zlar tahlili shu bosqichda qilinadi va matnga tabiiy joylashtiriladi.",
                time: "3–5 kun",
            },
            {
                t: "Dizayn",
                d: "Figma'da bosh sahifa va ikkita ichki sahifa chiziladi. Siz tasdiqlaganingizdan keyin qolgan sahifalar shu uslubda davom ettiriladi. Kelishilgan doiradagi tuzatishlar bepul.",
                time: "5–10 kun",
            },
            {
                t: "Dasturlash",
                d: "Sayt Next.js yoki React asosida quriladi, admin panel sozlanadi, ko'p tilli kontent tizimi va integratsiyalar ulanadi. Har hafta oraliq versiyani ko'rasiz.",
                time: "10–15 kun",
            },
            {
                t: "Kontent va sinov",
                d: "Matn, rasm va hujjatlar joylashtiriladi. Barcha brauzer, qurilma va tillarda sinov o'tkaziladi, PageSpeed o'lchanadi va 90 ballga yaqinlashtiriladi.",
                time: "3–5 kun",
            },
            {
                t: "Ishga tushirish va topshirish",
                d: "Domen ulanadi, analitika va Search Console sozlanadi, sayt indeksatsiyaga yuboriladi. Jamoangizga admin panelni o'rgatamiz va video-qo'llanma beramiz.",
                time: "1–2 kun",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan korporativ saytlar",
        sub: "Har bir loyiha noldan chizilgan: tuzilma, dizayn, matn va texnik qism bizning jamoamiz tomonidan tayyorlangan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["ung-overseas", "cleanza", "mesmer"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Korporativ sayt yaratish bo'yicha eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "Korporativ sayt yaratish qancha turadi?",
                a: "Narxlar 9 000 000 so'mdan boshlanadi — bu 6–10 sahifali, ikki tilli, SEO'ga tayyor sayt. Individual dizayn va to'liq admin panel bilan variant 22 000 000 so'mdan. Filial tizimi, 1C integratsiyasi yoki shaxsiy kabinet kerak bo'lsa, narx loyihaga qarab hisoblanadi va odatda 45 mln so'mdan oshadi. Toshkent bozorida korporativ sayt 8–30 mln so'm oralig'ida turadi.",
            },
            {
                q: "Korporativ sayt bilan landing yoki vizitka-sayt orasida farq nima?",
                a: "Landing va vizitka-sayt bir yoki bir necha sahifadan iborat bo'lib, asosan bitta taklifni ko'rsatadi. Korporativ sayt ko'p sahifali: har bir xizmat, loyiha va bo'lim o'z manziliga ega. Bu Google'da ancha ko'proq so'rov bo'yicha chiqish imkonini beradi. Byudjet cheklangan bo'lsa, landingdan boshlab keyin korporativ saytga kengaytirish mumkin.",
            },
            {
                q: "Sayt necha kunda tayyor bo'ladi?",
                a: "Standart tarif 12–18 ish kunida, Biznes tarifi 25–35 ish kunida topshiriladi. Murakkab integratsiyali loyihalar 2–4 oy oladi. Muddat sizdan matn, logotip, rasm va hujjatlar qanchalik tez kelishiga ham bog'liq — kontent oldindan tayyor bo'lsa, jarayon 20–30 foizga tezlashadi. Shoshilinch holatlarda bosh sahifa va aloqa bo'limini birinchi haftada ishga tushirib, qolgan sahifalarni keyin to'ldirish varianti ham bor.",
            },
            {
                q: "Admin panel nima uchun kerak va u qaysi tarifda bor?",
                a: "Admin panel orqali yangilik chiqarish, loyiha qo'shish, xizmat matni yoki narxini o'zgartirish dasturchisiz bajariladi. U Biznes va Korporativ+ tariflarida bor. Standart tarifda admin panel yo'q, lekin olti oylik qo'llab-quvvatlash davomida tuzatishlarni biz bepul kiritamiz. Kontenti kam o'zgaradigan kompaniyalarga bu tejamkorroq.",
            },
            {
                q: "Sayt necha tilda bo'ladi?",
                a: "Standart tarifda ikki til (o'zbek va rus), Biznes tarifida uch til (o'zbek, rus, ingliz) kiradi. Har bir til alohida manzilga ega bo'ladi va hreflang belgilanadi — bu Google'ga to'g'ri versiyani ko'rsatish demak. Qo'shimcha til kerak bo'lsa, uni ham qo'shamiz; har bir yangi til taxminan 1,5–3 mln so'm qo'shadi, chunki tarjima va tekshiruv ham ish talab qiladi.",
            },
            {
                q: "Sayt Google'da yuqoriga chiqadimi?",
                a: "Sayt qidiruvga tayyor holda topshiriladi: to'g'ri tuzilma, meta teglar, semantik sarlavhalar, sitemap, Schema.org va tezlik optimizatsiyasi. Bu — asos. Kam raqobatli so'rovlar bo'yicha natija 2–3 oydan keyin ko'rinadi. Raqobatli so'rovlar uchun doimiy SEO ishi va blog kerak; buni alohida xizmat sifatida olib boramiz.",
            },
            {
                q: "Eski saytimni yangi saytga ko'chira olasizmi?",
                a: "Ha. Mavjud matn, rasm va hujjatlarni yangi saytga ko'chiramiz. Eng muhimi — eski manzillarni saqlaymiz yoki 301-yo'naltirish qo'yamiz, shunda Google'dagi mavjud o'rningiz va tashqi havolalaringiz yo'qolmaydi. Ko'chirishdan oldin eski saytning to'liq zaxira nusxasini olamiz, ishga tushgandan keyin esa bir oy davomida Search Console'dagi xatolarni kuzatib boramiz va tuzatamiz.",
            },
            {
                q: "Keyinchalik internet-do'kon yoki yangi bo'lim qo'shsam bo'ladimi?",
                a: "Ha, sayt kengaytirish hisobga olingan holda quriladi. Katalog, onlayn to'lov, shaxsiy kabinet yoki yangi bo'limlarni keyinchalik qo'shish mumkin — noldan qurishga hojat qolmaydi. Odatda bunday kengaytirish yangi loyihaning 30–50 foizi narxida chiqadi. Agar savdo rejalaringiz aniq bo'lsa, buni boshidanoq ayting: tuzilmani shunga moslab chizamiz va keyinchalik qayta ishlash kamayadi.",
            },
            {
                q: "Sayt kodi va domeni kimga tegishli bo'ladi?",
                a: "Sayt kodi, domen va barcha kontent sizga tegishli. Topshirish paytida repozitoriy, admin panel va hosting kirish ma'lumotlarini beramiz. Kelajakda boshqa jamoa bilan ishlashni tanlasangiz, hech narsa to'sqinlik qilmaydi. Biz mijozni yopiq platformaga bog'lab qo'ymaymiz — bu shartnomada ham alohida band bilan yoziladi, shuning uchun og'zaki va'da darajasida qolmaydi.",
            },
            {
                q: "Toshkentdan tashqarida bo'lsam ham ishlay olasizmi?",
                a: "Ha. Loyihalarning katta qismini masofadan olib boramiz: muloqot Telegram va onlayn uchrashuvlar orqali, hujjatlar elektron rasmiylashtiriladi. O'zbekistonning istalgan viloyatidan hamda chet eldan buyurtma qabul qilamiz. Kerak bo'lsa Toshkentda jonli uchrashuv tashkil qilamiz. Savollaringiz bo'lsa +998 90 954 12 62 raqamiga qo'ng'iroq qiling — birinchi suhbat bepul va majburiyatsiz.",
            },
        ],
    },
    cta: {
        h: "Kompaniyangiz uchun korporativ sayt kerakmi?",
        p: "Bepul konsultatsiyada sayt qanday vazifani bajarishi kerakligini aniqlaymiz, qaysi tarif yetarli ekanini aytamiz va aniq narx bilan muddatni belgilaymiz. Majburiyat yo'q.",
        button: "Bepul konsultatsiya olish",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Korporativ sayt yaratish jarayoni — kompaniya sayti maketi ekranda",
            caption: "Korporativ sayt kompaniyangizning rasmiy yuzi: xizmatlar, loyihalar va aloqa bitta tizimda.",
        },
        {
            src: "/assets/img/projects/ung-overseas.webp",
            alt: "UNG Overseas korporativ sayti — Innobek qurgan ko'p tilli kompaniya sayti",
            caption: "UNG Overseas — ta'lim va konsalting yo'nalishidagi ko'p tilli korporativ sayt.",
        },
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Korporativ sayt ishlab chiqish bosqichlari — tahlil, dizayn, dasturlash va sinov",
            caption: "Oltita bosqich: tahlildan topshirishgacha, har birida natijani ko'rasiz.",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Korporativ sayt SEO optimizatsiyasi va Google'da ko'rinish ko'rsatkichlari",
            caption: "Har bir xizmat sahifasi alohida so'rov bo'yicha qidiruvda chiqadi.",
        },
        {
            src: "/assets/img/projects/mesmer.webp",
            alt: "Mesmer kompaniyasining korporativ sayti — qurilish sohasi uchun portfolio bo'limi",
            caption: "Mesmer — qurilish kompaniyasi uchun portfolio va xizmatlar katalogi bilan sayt.",
        },
    ],
    related: ["internet-dokonlar", "landing-page", "vizitka-saytlar", "seo", "ux-ui-dizayn"],
};

const ru = {
    meta: {
        title: "Создание корпоративного сайта — цена от 9 млн сум | Innobek",
        description:
            "Создание корпоративного сайта для компании от 9 млн сум. Многостраничная структура, админ-панель, несколько языков и SEO. Срок 12–35 рабочих дней.",
        keywords: [
            "корпоративный сайт",
            "создание корпоративного сайта",
            "корпоративный сайт цена",
            "сайт для компании",
            "сайт для бизнеса",
            "многостраничный сайт",
            "создание сайта в Ташкенте",
            "заказать сайт",
            "разработка сайта",
        ],
    },
    hero: {
        eyebrow: "Корпоративные сайты",
        h1: "Создание корпоративного сайта — от 9 млн сум",
        lead:
            "Клиент, партнёр и инвестор ищут вас в интернете ещё до первой встречи. Корпоративный сайт — официальное лицо компании: услуги, проекты, команда и документы в одной системе, на двух-трёх языках и в виде, который находит Google.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "60+ сданных веб-проектов",
            "На Next.js и React",
            "Языки: uz / ru / en",
            "6 месяцев техподдержки",
        ],
    },
    intro: {
        h: "Что такое корпоративный сайт и что он даёт компании?",
        p: [
            "Корпоративный сайт — это многостраничный сайт, где информация о компании изложена системно. В отличие от одностраничного лендинга, здесь есть отдельные разделы: о компании, услуги или продукция, реализованные проекты, команда, сертификаты и лицензии, новости, вакансии и контакты. У каждого раздела свой адрес, а значит, каждый может выходить в Google по собственному запросу.",
            "Сегодня сайт компании — уже не опция из категории «было бы неплохо». В тендере, на переговорах с зарубежным поставщиком, при оформлении банковского кредита или заключении крупного договора первым делом спрашивают адрес официального сайта. Компанию без сайта или с сайтом, который не обновлялся с 2015 года, не воспринимают всерьёз, даже если с документами всё в порядке.",
            "Innobek делает корпоративный сайт не украшением, а рабочим инструментом. Сначала мы разбираемся, кому и что продаёт ваша компания, и только потом рисуем структуру страниц под эту логику. Тексты, дизайн и техническая часть согласованы друг с другом: читатель находит нужный ответ меньше чем за три клика, а форма заявки всегда остаётся в поле зрения.",
            "Сайт собирается на Next.js или React, управляется через админ-панель и сдаётся подготовленным к поиску. Мы не запираем проект в закрытом конструкторе — исходный код передаётся вам, и при желании вы в любой момент можете передать проект другой команде. Это снижает зависимость от подрядчика и в долгосрочной перспективе работает на вас.",
        ],
    },
    definition: {
        term: "Что такое корпоративный сайт?",
        text:
            "Корпоративный сайт — это многостраничный сайт, который представляет услуги, проекты, команду и контакты компании в одной системе. Он решает задачи доверия, привлечения клиентов и официального представительства.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не платные дополнения — всё есть даже в базовом тарифе.",
        items: [
            "Бесплатная консультация, бизнес-анализ и письменное техзадание",
            "Структура сайта (sitemap) и логика блоков каждой страницы",
            "Двух- или трёхъязычная система контента (узбекский / русский / английский)",
            "Адаптивный дизайн, проверенный на всех устройствах",
            "Помощь с регистрацией домена и настройка DNS",
            "SSL-сертификат (HTTPS) и защищённые формы заявок",
            "Техническое SEO: мета-теги, иерархия заголовков, sitemap.xml, robots.txt",
            "Разметка Schema.org — блоки Organization, Service и FAQ",
            "Подключение Google Analytics, Search Console и Яндекс.Метрики",
            "Оптимизация скорости: сжатие изображений, lazy-load, кеширование",
            "Уведомления о заявках в Telegram и дубль на почту",
            "Видеоинструкция по управлению и встреча-передача проекта",
            "6 месяцев технической поддержки после запуска",
        ],
    },
    benefits: {
        eyebrow: "Зачем нужен",
        h: "Что корпоративный сайт даёт бизнесу",
        sub: "Сайт — не расход, а инструмент продаж и репутации. Ниже — на что он влияет конкретно.",
        items: [
            {
                t: "Доверие за первые 10 секунд",
                d: "Перед договором клиент вас проверяет. Аккуратный сайт, реальные проекты, фотографии команды и лицензии — самое дешёвое доказательство того, что вы серьёзная компания. Без этого клиент уходит к конкуренту.",
            },
            {
                t: "Постоянные обращения из Google",
                d: "Отдельная страница под каждую услугу — это дополнительный шанс выйти по своему запросу. Десять грамотно написанных страниц услуг через 2–4 месяца начинают приносить десятки обращений в месяц без оплаты за рекламу.",
            },
            {
                t: "Тендеры и крупные контракты",
                d: "В госзакупках, международном партнёрстве и работе с банками официальный сайт часто обязателен. Его отсутствие или неубедительный вид останавливают заявку ещё на этапе проверки документов.",
            },
            {
                t: "Многоязычная аудитория",
                d: "Узбекский, русский и английский в одной системе, каждый на своём адресе. Зарубежный партнёр читает вас на своём языке — переговоры начинаются без переводчика и идут заметно легче.",
            },
            {
                t: "Привлечение кадров",
                d: "С разделами вакансий и команды сайт становится HR-инструментом. Кандидат видит культуру компании, офис и проекты — это действует сильнее, чем объявление на job-сайте.",
            },
            {
                t: "Управление в ваших руках",
                d: "Через админ-панель вы публикуете новости, добавляете проекты, меняете цены и тексты. Не нужно ждать разработчика и доплачивать за каждую мелкую правку.",
            },
            {
                t: "Фундамент для маркетинга",
                d: "Реклама в Google Ads, Instagram или Telegram должна куда-то вести. Без убедительного сайта рекламный бюджет не превращается в конверсию: трафик приходит и уходит, не оставив заявку.",
            },
        ],
    },
    audience: {
        eyebrow: "Кто заказывает",
        h: "Какому бизнесу нужен корпоративный сайт",
        sub: "Сферы, где одной страницы недостаточно и где доверие приходится доказывать.",
        items: [
            {
                t: "Производство и заводы",
                d: "Каталог продукции, сертификаты качества, производственные мощности и дилерский раздел. Вся техническая информация для покупателя и партнёра собрана в одном месте.",
            },
            {
                t: "Строительство и проектирование",
                d: "Галерея сданных объектов, лицензии, перечень услуг и описание процесса — то, что проверяют в тендере в первую очередь.",
            },
            {
                t: "Медицина: клиники и лаборатории",
                d: "Направления, врачи, цены и онлайн-запись. Для пациента доверие на первом месте: дипломы, опыт и реальные отзывы должны быть на виду.",
            },
            {
                t: "Образование: вузы, центры, академии",
                d: "Программы, преподаватели, условия приёма и стоимость. Заявки принимаются прямо на сайте и попадают в CRM.",
            },
            {
                t: "Логистика, торговля и дистрибуция",
                d: "География услуг, калькулятор тарифов, список партнёров и отслеживание груза — всё объединено в одной системе.",
            },
            {
                t: "Финансы, право и консалтинг",
                d: "Экспертиза, команда, кейсы и статьи. В этих сферах контент на сайте напрямую превращается в доверие и обращения.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость корпоративного сайта — три тарифа",
        sub: "Цены открытые. В каждый тариф входят несколько языков, настройка домена, размещение на хостинге и поддержка.",
        note:
            "Указанные суммы — стартовый диапазон. Итоговая цена подтверждается после бесплатной консультации и зависит от числа страниц, интеграций и объёма контента. Оплата поэтапная: 50% предоплата, 50% при сдаче. Годовая оплата хостинга и домена (примерно 1–2 млн сум) в стоимость не входит.",
        tiers: [
            {
                name: "Стандарт",
                tagline: "Корпоративный сайт с быстрым запуском",
                price: "9 000 000",
                priceNote: "сум — в зависимости от проекта",
                term: "12–18 рабочих дней",
                features: [
                    "6–10 страниц: главная, о компании, услуги, проекты, контакты",
                    "Дизайн на готовой основе с адаптацией под ваш бренд",
                    "Двуязычный интерфейс (узбекский и русский), третий язык — опция",
                    "Полная адаптация под телефон, планшет и компьютер",
                    "Форма заявки и уведомления в Telegram",
                    "Техническое SEO: мета-теги, sitemap, robots.txt, Schema.org",
                    "Подключение Google Analytics и Search Console",
                    "Настройка домена, хостинга и SSL",
                    "Правки контента в период поддержки — на нашей стороне",
                    "6 месяцев технической поддержки",
                ],
                best: "Компаниям без сайта или с устаревшим сайтом, которым нужно быстро и достойно заявить о себе",
            },
            {
                name: "Бизнес",
                tagline: "Индивидуальный дизайн и полная админ-панель",
                price: "22 000 000",
                priceNote: "сум — в зависимости от проекта",
                term: "25–35 рабочих дней",
                features: [
                    "12–25 страниц, структура с запасом на расширение",
                    "Индивидуальный дизайн с нуля, с макетом в Figma",
                    "Полная админ-панель: страницы, услуги, проекты, новости, вакансии",
                    "Три языка (uz / ru / en), каждый редактируется отдельно",
                    "Модуль каталога услуг и портфолио с фильтрами и категориями",
                    "Раздел блога или новостей — для постоянного SEO-трафика",
                    "Разделы вакансий и команды",
                    "Продающие тексты (копирайтинг)",
                    "Расширенное SEO: анализ ключевых слов, перелинковка, скорость",
                    "Интеграция с CRM (amoCRM, Bitrix24) или Google Sheets",
                    "Анимации и scroll-эффекты",
                    "6 месяцев технической поддержки",
                ],
                best: "Компаниям, которые регулярно публикуют новости и сами ведут портфолио и вакансии",
                featured: true,
            },
            {
                name: "Корпоративный+",
                tagline: "Индивидуальное решение и интеграции",
                price: "По договору",
                priceNote: "— от 45 млн сум",
                term: "По проекту, 2–4 месяца",
                features: [
                    "Разделы под филиалы и подразделения, региональные страницы",
                    "Личный кабинет для дилеров, партнёров или клиентов",
                    "Интеграция с 1С, ERP и складскими системами",
                    "Калькулятор, конфигуратор, бронирование или тендерный модуль",
                    "Документооборот и система внутренних заявок",
                    "Инфраструктура под нагрузку: CDN, мониторинг, резервные копии",
                    "Аудит безопасности и управление правами доступа",
                    "Персональный менеджер проекта и согласованный SLA",
                ],
                best: "Холдингам с филиалами, проектам со сложными интеграциями и высокой нагрузкой",
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как создаётся корпоративный сайт",
        sub: "Шесть этапов. В конце каждого вы видите результат и подтверждаете его письменно.",
        steps: [
            {
                t: "Анализ и техзадание",
                d: "Изучаем ваш бизнес, путь клиента и трёх конкурентов. Фиксируем документом, какую задачу должен решать сайт — дальше все решения опираются на этот документ.",
                time: "2–3 дня",
            },
            {
                t: "Структура и тексты",
                d: "Готовим карту страниц, блоки и тексты для каждой страницы. Анализ ключевых слов делается на этом этапе, и сами слова естественно закладываются в текст.",
                time: "3–5 дней",
            },
            {
                t: "Дизайн",
                d: "Рисуем в Figma главную и две внутренние страницы. После вашего подтверждения стиль распространяется на остальные. Правки в согласованном объёме бесплатны.",
                time: "5–10 дней",
            },
            {
                t: "Разработка",
                d: "Собираем сайт на Next.js или React, настраиваем админ-панель, многоязычную систему контента и интеграции. Промежуточную версию вы видите каждую неделю.",
                time: "10–15 дней",
            },
            {
                t: "Контент и тестирование",
                d: "Наполняем текстами, изображениями и документами. Тестируем во всех браузерах, на всех устройствах и языках, замеряем PageSpeed и подтягиваем его к 90 баллам.",
                time: "3–5 дней",
            },
            {
                t: "Запуск и передача",
                d: "Подключаем домен, настраиваем аналитику и Search Console, отправляем сайт на индексацию. Обучаем вашу команду работе с админ-панелью и выдаём видеоинструкцию.",
                time: "1–2 дня",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Корпоративные сайты, которые мы сделали",
        sub: "Каждый проект собран с нуля: структура, дизайн, тексты и разработка — работа нашей команды.",
        cta: "Смотреть все проекты",
        slugs: ["ung-overseas", "cleanza", "mesmer"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Короткие ответы на самые частые вопросы о создании корпоративного сайта.",
        items: [
            {
                q: "Сколько стоит создание корпоративного сайта?",
                a: "Цены начинаются от 9 000 000 сум — это сайт на 6–10 страниц, двуязычный и готовый к SEO. Вариант с индивидуальным дизайном и полной админ-панелью — от 22 000 000 сум. Если нужна система филиалов, интеграция с 1С или личный кабинет, цена считается по проекту и обычно превышает 45 млн сум. На рынке Ташкента корпоративный сайт стоит 8–30 млн сум.",
            },
            {
                q: "Чем корпоративный сайт отличается от лендинга или сайта-визитки?",
                a: "Лендинг и сайт-визитка состоят из одной или нескольких страниц и показывают в основном одно предложение. Корпоративный сайт многостраничный: у каждой услуги, проекта и раздела свой адрес. Это даёт заметно больше запросов в Google. При ограниченном бюджете можно начать с лендинга и позже расшириться до корпоративного сайта.",
            },
            {
                q: "За сколько дней будет готов сайт?",
                a: "Тариф Стандарт сдаём за 12–18 рабочих дней, тариф Бизнес — за 25–35 рабочих дней. Проекты со сложными интеграциями занимают 2–4 месяца. Срок зависит и от того, как быстро вы предоставите тексты, логотип, фотографии и документы: с готовым контентом процесс ускоряется на 20–30 процентов.",
            },
            {
                q: "Зачем нужна админ-панель и в каком тарифе она есть?",
                a: "Через админ-панель вы публикуете новости, добавляете проекты, меняете тексты услуг и цены без разработчика. Она входит в тарифы Бизнес и Корпоративный+. В тарифе Стандарт админ-панели нет, но в течение шести месяцев поддержки правки вносим мы бесплатно. Компаниям с редко меняющимся контентом так экономнее.",
            },
            {
                q: "На скольких языках будет сайт?",
                a: "В тариф Стандарт входят два языка (узбекский и русский), в тариф Бизнес — три (узбекский, русский, английский). У каждого языка свой адрес и проставленный hreflang, чтобы Google показывал нужную версию. Если нужен дополнительный язык, мы добавим и его: каждый новый язык обходится примерно в 1,5–3 млн сум, потому что перевод и вычитка тоже требуют работы.",
            },
            {
                q: "Выйдет ли сайт в топ Google?",
                a: "Сайт сдаётся подготовленным к поиску: правильная структура, мета-теги, семантические заголовки, sitemap, Schema.org и оптимизация скорости. Это база. По низкоконкурентным запросам результат виден через 2–3 месяца. Для конкурентных запросов нужна постоянная SEO-работа и блог — ведём это отдельной услугой. Никто честно не обещает топ-1 за месяц: поисковая выдача так не работает.",
            },
            {
                q: "Можно ли перенести мой старый сайт?",
                a: "Да. Переносим существующие тексты, изображения и документы. Главное — сохраняем старые адреса или ставим 301-редиректы, чтобы позиции в Google и внешние ссылки не потерялись. Перед переносом делаем полную резервную копию старого сайта, а после запуска месяц отслеживаем ошибки в Search Console и исправляем их.",
            },
            {
                q: "Можно ли позже добавить интернет-магазин или новый раздел?",
                a: "Да, сайт строится с расчётом на расширение. Каталог, онлайн-оплату, личный кабинет или новые разделы можно добавить позже — переделывать с нуля не придётся. Обычно такое расширение обходится в 30–50 процентов стоимости нового проекта. Если планы по онлайн-продажам уже есть, скажите сразу: заложим структуру под них с самого начала.",
            },
            {
                q: "Кому принадлежат код сайта и домен?",
                a: "Код сайта, домен и весь контент принадлежат вам. При сдаче мы передаём репозиторий, доступы к админ-панели и хостингу. Если в будущем вы решите работать с другой командой, ничто этому не помешает. Мы не привязываем клиента к закрытой платформе — это прописано отдельным пунктом договора, а не остаётся устным обещанием.",
            },
            {
                q: "Работаете ли вы, если я не в Ташкенте?",
                a: "Да. Большинство проектов ведём удалённо: общение в Telegram и на онлайн-встречах, документы оформляем электронно. Принимаем заказы из любого региона Узбекистана и из-за рубежа. При необходимости организуем личную встречу в Ташкенте. Если есть вопросы, позвоните по номеру +998 90 954 12 62 — первая консультация бесплатная и ни к чему не обязывает.",
            },
        ],
    },
    cta: {
        h: "Нужен корпоративный сайт для вашей компании?",
        p: "На бесплатной консультации определим, какую задачу должен решать сайт, скажем, какого тарифа достаточно, и зафиксируем точную цену и срок. Без обязательств.",
        button: "Получить бесплатную консультацию",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Создание корпоративного сайта — макет сайта компании на экране",
            caption: "Корпоративный сайт — официальное лицо компании: услуги, проекты и контакты в одной системе.",
        },
        {
            src: "/assets/img/projects/ung-overseas.webp",
            alt: "Корпоративный сайт UNG Overseas — многоязычный сайт компании от Innobek",
            caption: "UNG Overseas — многоязычный корпоративный сайт в сфере образования и консалтинга.",
        },
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Этапы разработки корпоративного сайта — анализ, дизайн, разработка и тестирование",
            caption: "Шесть этапов: от анализа до передачи, результат виден на каждом.",
        },
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "SEO-оптимизация корпоративного сайта и показатели видимости в Google",
            caption: "Каждая страница услуги выходит в поиске по собственному запросу.",
        },
        {
            src: "/assets/img/projects/mesmer.webp",
            alt: "Корпоративный сайт компании Mesmer — раздел портфолио для строительной сферы",
            caption: "Mesmer — сайт строительной компании с портфолио и каталогом услуг.",
        },
    ],
    related: ["internet-dokonlar", "landing-page", "vizitka-saytlar", "seo", "ux-ui-dizayn"],
};

const content = { uz, ru };

export default content;
